import { extractProperty } from "./extractProperty"

export type ProductFilter = {
  label: string
  options: {
    id: number
    name: string
    value: string
  }[]
}

export function extractProductsAndFilters({
  products,
  filters,
}: {
  products: any[]
  filters?: any
}) {
  // Use Sets to collect unique values
  const keyFeatureSet = new Set<string>()

  const productCategoryIds = products
    ?.map((p) =>
      p.properties
        .find((p: any) => p.propertyName === "productCategory")
        ?.propertyValue?.contentList?.map((c: any) => c.id),
    )
    ?.flat()

  products.forEach((product) => {
    const properties = product.properties || []
    const features = properties
      .find((p: any) => p.propertyName === "productKeyFeatures")
      ?.propertyValue?.blocks?.map((feature: any) => extractProperty(feature, "text"))
    if (features && Array.isArray(features))
      features.forEach((f: string) => f && keyFeatureSet.add(f))
  })

  const categories = filters
    ?.filter((el: any) => el?.node?.contentType?.alias === "productCategory")
    ?.map((el: any) => ({
      id: el.node.id,
      name: el.node.name,
      value: el.node.properties?.[0]?.propertyValue?.value,
    }))
  const filteredCategories: ProductFilter = {
    label: "categories",
    options: categories?.filter((el: any) => productCategoryIds?.includes(el.id)),
  }
  const subCategories: ProductFilter = {
    label: "subCategories",
    options: filters
      ?.filter((el: any) => el?.node?.contentType?.alias !== "productCategory")
      ?.map((el: any) => ({
        id: el.node.id,
        name: el.node.name,
        value: el.node.properties?.[0]?.propertyValue?.value,
      })),
  }
  // Convert Sets to arrays for filters
  const keyFeatures: ProductFilter = {
    label: "keyFeatures",
    options: Array.from(keyFeatureSet).map((value, idx) => ({ id: idx + 1, name: value, value })),
  }

  return {
    products,
    filters: {
      categories: filteredCategories,
      subCategories: subCategories,
      productKeyFeatures: keyFeatures,
    },
  }
}
